import { HighlightLogo as HighlightLogo$1, LogoImage } from '@cbhq/cdx-components';
import { getComposePageSeoImageUrlAndDescription } from '../globals/composePage.js';
import { mapEntryLink } from '../globals/navlink.js';
import { CONTENTFUL_COMPONENTS_STYLE_MAP } from './contentToPropsMap.js';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_LOGO_CONTENT_MODEL_ID = 'cdxHighlightLogo';
function HighlightLogo({
  link,
  anchor,
  subhead,
  headline,
  logoList,
  gridColumns = 5,
  style: styleProp,
  hasSpacingTop = false
}) {
  const style = CONTENTFUL_COMPONENTS_STYLE_MAP[styleProp];
  const seeEntryLink = mapEntryLink(link);
  return /*#__PURE__*/jsx(HighlightLogo$1, {
    style: style,
    hasSpacingTop: hasSpacingTop,
    anchor: anchor,
    subhead: subhead,
    headline: headline,
    gridColumns: gridColumns,
    ctaUrl: seeEntryLink?.url,
    ctaLabel: seeEntryLink?.label,
    children: logoList && logoList.map(({
      fields: {
        link,
        icon
      }
    }, index) => {
      const logoLink = mapEntryLink(link);
      const _getComposePageSeoIma = getComposePageSeoImageUrlAndDescription(link?.fields?.composePage),
        url = _getComposePageSeoIma.url,
        description = _getComposePageSeoIma.description;
      const imageSrc = icon?.fields?.file?.url || url;
      const imageAlt = icon?.fields?.description || description;
      return /*#__PURE__*/jsx(LogoImage, {
        label: logoLink?.label,
        imageAlt: imageAlt,
        imageSrc: imageSrc,
        url: logoLink?.url,
        imageFit: "contain"
      }, logoLink?.label + index);
    })
  });
}
export { HIGHLIGHT_LOGO_CONTENT_MODEL_ID, HighlightLogo };
//# sourceMappingURL=HighlightLogo.js.map
